// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3cd90a67","455":"1d39c3ce","977":"f607455b"}[chunkId] + ".chunk.js";
};